export default __webpack_public_path__ + "3NhZMf--left-arrow.svg";